import { TableCellType } from "components/LazyTable";
import SortableTable from "components/SortableTable";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { useIntl } from "react-intl";
import {
  ListRequestOfSkuLearningLevelFilter,
  ListResponseOfSkuLearningLevel,
} from "services/KnowfullyAdminClient";
import { SkuLearningLevelWithId } from "types/sku-related-types";

const SkuLearningLevels = ({ skuId }: { skuId: string }) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const { data, isFetching } = useStrictQuery<ListResponseOfSkuLearningLevel>(
    ["skuLearningLevels", skuId],
    () =>
      skuService.getSkuLearningLevels(
        skuId,
        ListRequestOfSkuLearningLevelFilter.fromJS({
          sortField: "createdOn",
          sortDescending: true,
        })
      ),
    { enabled: !!skuId }
  );

  const cells: Array<TableCellType> = [
    {
      accessor: "learningLevel.value",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "skuLearningLevelLabel" }),
    },
  ];

  return (
    <SortableTable
      {...{
        rows: data?.data! as SkuLearningLevelWithId[],
        loading: isFetching,
        dense: true,
        cells,
        tableRowPerPage: 5,
      }}
    />
  );
};

export default withErrorBoundary(SkuLearningLevels);
